module.exports = "https://health.dajiuxing.com.cn/img/assets/theHeartList/red.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FtheHeartList%2Fred.png
// module id = +yQC
// module chunks = 93